import { Injectable, inject } from '@angular/core';
import { Auth, User, user } from '@angular/fire/auth';
import {
  DocumentData,
  collection,
  onSnapshot,
  query,
  where,
  CollectionReference,
  DocumentReference,
  QuerySnapshot,
  Firestore,
} from '@angular/fire/firestore';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FirebaseService {
  private firestore: Firestore = inject(Firestore);
  public auth: Auth = inject(Auth);
  public user$: Observable<User | null> = user(this.auth);
  propertyCollectionRef: CollectionReference | undefined;
  propCollection: BehaviorSubject<DocumentData[]> = new BehaviorSubject(
    [] as DocumentData[],
  ); // TODO: set up a property model
  propertyCollectionRefNew: DocumentReference | undefined;

  constructor() {
    this.user$.subscribe((u) => {
      console.log('Listening to user in firebase service', u);
      if (u) {
        const UID = u.uid;
        try {
          const propertyCollection = collection(this.firestore, 'Properties');
          const userPropertiesQuery = query(
            propertyCollection,
            where('user', '==', UID),
          );

          this.propertyCollectionRef = propertyCollection;

          onSnapshot(userPropertiesQuery, (propertySnapshot: QuerySnapshot) => {
            const tmpList: DocumentData[] = [];

            propertySnapshot.forEach((property) => {
              const { id } = property;
              const docData = property.data();

              tmpList.push({ id, ...docData });
            });
            this.propCollection.next(tmpList);
          });
        } catch (error) {
          console.error('Error setting up property collection', error);
        }
      } else {
        this.propertyCollectionRef = undefined;
      }
    });
  }
}
